import { RCCHookToast, RCCHooksUseEffectFetchData } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";

function useEffectFetchData<T> (apiRoute: string, urlParameters?: object, then?: (data: { data: T }) => void,  useEffectDeps?: any[], skipInitialRender?: boolean) : {
	loading: boolean;
	data: T;
	errorFetching: boolean;
	loadData: () => void;
} {

	const {translate} = useTranslation();
	const {addToast} = RCCHookToast();

	return RCCHooksUseEffectFetchData(apiRoute, {
		urlParameters,
		catchError: (err) => standardErrorMessages(err, translate("Erro ao buscar os dados"), addToast),
		skipInitialRender,
		then
	}, useEffectDeps);
}

export default useEffectFetchData;
